export default __webpack_public_path__ + "2bbafb854a3ebfc1d7db97172a35e10f.png";